
import { HttpWorkOrderList, HttpImportWorkOrder, HttpExportWorkOrder, HttpWorkOrderSearchList, HttpBatchConfirmWorkOrder, HttpCancelWorkOrder, HttpConfirmWorkOrder } from '@/service/workorder';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import mixin from "./mixin";
import compAdd from "./add";
import compUpdate from "./update";
export default {
    mixins: [TableList, mixin],
    components: {
        compAdd,
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            workOrderSearchList: []
        };
    },
    created() {
        this.getWorkOrderSearchList();
        this.nobill = this.handleAuth('fbb.workorder.nocostimport')
    },
    methods: {
        ajaxRequest: HttpWorkOrderList,
        interceptRequest(data) {
            const warehouseId = data.search.warehouseId;
            data.warehouseId = warehouseId;
            delete data.search.warehouseId;
            return data
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "export":
                    this.handleWebfs(
                        HttpExportWorkOrder,
                        this.interceptRequest(JSON.parse(JSON.stringify(this.formData))),
                        { executor: 'request', download: true }
                    );
                    break;
                case "add":
                    this.operate = {
                        show: true,
                        title: '添加',
                        width: 'large',
                        component: 'compAdd',
                        showFooter: false,
                    }
                    break;
                case "confirm":
                    this.operate = {
                        show: true,
                        alert: 'primary',
                        params: { id: params },
                        title: '确认',
                        ajaxRequest: HttpConfirmWorkOrder,
                        showDesc: false,
                        formdata: [
                            {
                                label: '备注',
                                tag: "vTextarea",
                                key: 'remark',
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            }
                        ]
                    }
                    break;
                case "batchConfirm":
                    this.operate = {
                        show: true,
                        alert: 'info',
                        params: { idList: params.split(',') },
                        title: '批量确认',
                        ajaxRequest: HttpBatchConfirmWorkOrder,
                        showDesc: false,
                        formdata: [
                            {
                                label: '备注',
                                tag: "vTextarea",
                                key: 'remark',
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            }
                        ]
                    }
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: '取消',
                        ajaxRequest: HttpCancelWorkOrder,
                        showDesc: false,
                        formdata: [
                            {
                                label: '备注',
                                tag: "vTextarea",
                                key: 'remark',
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            }
                        ]
                    }
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: "导入数据",
                        width: 460,
                        showFooter: false,
                        name: "excelFile",
                        component: "compUpload",
                        ajaxRequest: HttpImportWorkOrder,
                        download: () => {
                            this.handleWebfs("/static/template/service_workOrdeTMP.xlsx", {}, {
                                executor: 'download',
                                type: 'url'
                            });
                        }
                    };
                    break;
                case "importNobill":
                    this.operate = {
                        show: true,
                        title: "导入(不计成本)数据",
                        width: 460,
                        showFooter: false,
                        name: "multipartFile",
                        component: "compUpload",
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/ServiceWorkOrder/importWorkOrdersNoCost",
                        download: () => {
                            this.handleWebfs("/static/template/service_workOrdeTMP.xlsx", {}, {
                                executor: 'download',
                                type: 'url'
                            });
                        }
                    };
                    break;

                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "workorderorderUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;

            }
        },
        getOperateNodeMap(row) {
            const { id, workOrderStatus } = row;
            return [
                {
                    label: this.$t('global.common.query'),
                    to: {
                        name: "workorderorderUpdate",
                        params: {
                            type: 'query',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    params: id,
                    show: workOrderStatus == 0,
                    to: {
                        name: "workorderorderUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id }
                    },
                },
                {
                    label: "确认",
                    params: id,
                    show: workOrderStatus == 0,
                    operate: 'confirm',
                },
                {
                    label: this.$t('global.common.cancel'),
                    params: id,
                    show: workOrderStatus == 0,
                    operate: 'cancel',
                },
            ];
        },
        //事务项列表 下拉
        getWorkOrderSearchList() {
            HttpWorkOrderSearchList({
                status: 0,
            }).then(res => {
                this.workOrderSearchList = (res.data || []).map(item => {
                    return {
                        value: item.id,
                        label: item.transactionName
                    }
                })
            }).catch(err => {
                this.$VMessage.error(err.message);
            })
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList', 'getAdminTransferWarehouse','getBillcusWareList']),
        ToolsData() {
            return [
                {
                    label: "添加",
                    theme: "primary",
                    operate: 'add',
                    // to: {
                    //     name: "workorderorderUpdate",
                    //     params: {
                    //         type: 'add'
                    //     }
                    // }
                },
                {
                    label: "导入",
                    theme: "primary",
                    operate: 'import',
                },
                {
                    label: "批量确认",
                    theme: "info",
                    operate: 'batchConfirm',
                    batch: true,
                    more: true,
                },
                {
                    label: "导出",
                    operate: "export",
                    more: true,
                },
                {
                    label: "导入(不计成本)",
                    operate: "importNobill",
                    more: true,
                    show:this.nobill
                },

            ]
        },
        SearchsData() {
            return [
                {
                    label: "事务处理单号",
                    key: 'EQ_workOrderNo',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "来源单号",
                    key: 'EQ_sourceNo',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "事务处理计划单号",
                    key: 'EQ_workOrderPlanNo',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "状态",
                    key: 'EQ_workOrderStatus',
                    tag: 'vSelect',
                    options: this.getOrderStatus,
                },
                {
                    label: "关联单据类型",
                    key: 'EQ_relationOrderTypeId',
                    tag: 'vSelect',
                    options: this.getRelativeOrderTypes,
                },
                {
                    label: "关联单据号",
                    key: 'EQ_orderNo',
                    tag: 'vInput',
                },
                {
                    label: "仓库",
                    key: 'EQ_orgWarehouseCode',
                    tag: 'vSelect',
                    options: this.getAdminTransferWarehouse,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "项目",
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "组织",
                    key: 'EQ_organizationId',
                    tag: 'vSelect',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "事务类型包含",
                    key: 'EQ_serviceWorkOrderItemList.workOrderTypeId',
                    tag: 'vSelect',
                    options: this.workOrderSearchList,
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    style: "width:200px",
                    key: 'BT_updatedAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    formName: 'id',
                    width: 60,
                },
                // {
                //     title: 'No.',
                //     type: 'index',
                //     width: 60,
                // },
                {
                    title: '操作',
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: '客户组织',
                    key: 'organizationId',
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId),
                },
                {
                    title: '事务处理单号/来源单号',
                    key: 'workOrderNo',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.workOrderNo}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                            <div>{row.sourceNo || '--'}</div>
                        </div>
                    }
                    // render: (h, { row }) => {
                    //     return <div>
                    //         <div>{row.workOrderNo}</div>
                    //         <div>{row.sourceNo}</div>
                    //     </div>
                    // }
                },
                {
                    title: '事务处理计划单号',
                    key: 'workOrderPlanNo',
                    render: (h, { row }) => {
                        return <div>{row.workOrderPlanNo || '--'}</div>
                    },
                },
                {
                    title: '关联单据类型/关联单号/项目',
                    key: 'relationOrderTypeId',
                    render: (h, { row }) => {
                        return <div>
                            <div>{this.findRenderLabel(this.getRelativeOrderTypes, row.relationOrderTypeId) || '--' }</div>
                            <div>{row.orderNo || '--' }</div>
                            <div>{this.findRenderLabel(this.getCusproductList, row.lineId) || '--' }</div>
                        </div>
                    }
                },
                {
                    title: '状态',
                    key: 'workOrderStatus',
                    render: (h, { row }) => this.findRenderLabel(this.getOrderStatus, row.workOrderStatus, 'label', true),
                },
                {
                    title: '仓库',
                    render: (h, { row }) => {
                        return <div>{row.orgWarehouseCode} ({row.orgWarehouseTitle})</div>
                    },
                },
                // {
                //     title: '项目',
                //     key: 'lineId',
                //     render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId),
                // },

                {
                    title: '更新时间',
                    key: 'updatedAt',
                }];
        },
    },
};




